<template>
  <div class="lime-body">
    <div id="addUser">
      <div class="modal-dialog modal-dialog-centered" role="document">
         <div class="modal-content">
            <div class="modal-header">
               <flash-message class="myCustomClass"></flash-message>
               <h5 class="modal-title" id="exampleModalLabel">Add User</h5>
               <button type="button" class="close" id="close2" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
               <i class="material-icons">close</i>
               </button>
            </div>
            <form action="#" @keyup.enter="addUser()">
               <div class="modal-body">
               <p style="color:red;text-align:center">{{ errorMessage }}</p>
                  <p v-if="errors.length">
                <!-- <ul>
                  <li style='color:red' v-for="error in errors">{{ error }}</li>
                </ul> -->
                <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
              </p>
                  <div class="form-group">
                     <select class="form-control" ref="userrole" id="userrole" name="userrole" v-model="input.userrole"  @change="onChange($event)">
                        <option value="">Select Role*</option>
                        <option value="admin">Admin</option>
                        <option value="user">User</option>
                     </select>
                  </div>
                  <div class="form-group">
                     <input type="text" ref="name" class="form-control" placeholder="Firstname*" id="name" name="firstname" v-model="input.firstname" />
                  </div>
                  <div class="form-group">
                     <input type="text" ref="name" class="form-control" placeholder="Lastname*" id="name" name="lastname" v-model="input.lastname" />
                  </div>
                  <div class="form-group">
                     <input type="text" ref="username" class="form-control" placeholder="User Name*" id="username" name="username" v-model="input.username" />
                  </div>
                  <div class="form-group">
                     <input type="text" ref="email" class="form-control" placeholder="Email*" id="email" name="email" v-model="input.email" />
                  </div>
                  <div class="form-group">
                     <input type="password" ref="password" class="form-control" name="password" v-model="input.password" id="password" placeholder="Password*" />
                  </div>
                  <div class="form-group">
                     <input type="password" ref="cnfpassword" class="form-control" name="cnfpassword" v-model="input.cnfpassword" id="cnfpassword" placeholder="Confirm Password*" />
                  </div>
               </div>
               <div class="modal-footer">
                  <!-- <button type="button" class="btn btn-primary">Add</button> -->
                  <input type="button" class="btn btn-primary" value="Add" v-on:click="addUser()" />
                  <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')" >Cancel</button>
               </div>
            </form>
         </div>
      </div>
   </div>
</div>
</template>
<script>
  import axios from 'axios'
  import Action from './Action'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  require('vue-flash-message/dist/vue-flash-message.min.css')
  export default {
    name: 'User',
    props: ['rows'],
    components: {
      Loading
    },
    data () {
      return {
        isLoading: false,
        fullPage: true,
        errorMessage: '',
        tblCls: 'table',
        users: [],
        usersList: [],
        errors: [],
        i: 1,
        input: {
          email: '',
          firstname: '',
          lastname: '',
          username: '',
          userrole: '',
          password: '',
          cnfpassword: ''
        },
        columns: [
          {label: 'Stripe CustomerID', field: 'id'},
          {label: 'Name', field: 'name', headerClass: 'class-in-header second-class'},
          {label: 'User Name', field: 'username'},
          {label: 'Email', field: 'email'},
          {label: 'Role', field: 'role'},
          {label: 'Status', field: 'status'},
          {label: 'Action',
            component: Action,
            sortable: false
          }
        ],
        rows: this.usersList,
        filter: '',
        page: 1
      }
    },
    methods: {

      addUser () {
        this.errors = []
        var jwttoken = localStorage.getItem('jwt')
        var userrole = this.input.userrole
        var firstname = this.input.firstname
        var lastname = this.input.lastname
        var email = this.input.email
        var atposition = email.indexOf('@')
        var dotposition = email.lastIndexOf('.')
        if (userrole === '') {
          this.errors.push('Please select user role')
          this.$refs.userrole.focus()
        } else {
          if (userrole === 'user') {
            // this.errors = []
            var username = this.input.username
            var password = this.input.password
            var cnfpassword = this.input.cnfpassword
            if (this.input.firstname === '') {
              this.errors.push('Name is Required')
              this.$refs.firstname.focus()
            } else if (firstname.length < 3) {
              this.errors.push('Name must be 3 characters long')
              this.$refs.firstname.focus()
            } else if (this.input.email === '') {
              this.errors.push('Email is Required')
              this.$refs.email.focus()
            } else if (!this.emailValidator.validate(this.input.email)) {
              this.errors.push('Invalid contact Email')
              this.$refs.email.focus()
            } else {
              this.isLoading = true
              axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/createNewUser',
                {
                  firstname: firstname,
                  lastname: lastname,
                  email: email,
                  role: userrole
                }, {
                  headers: {
                    'x-access-token': jwttoken
                  }})
                .then(response => {
                  this.isLoading = false
                  this.$eventBus.$emit('listUser', 'User is Added successfully');
                  this.$emit('close')
                 })
                  .catch((error) => {
                    this.$eventBus.$emit('listUser', '','User could not be Added');
                    this.$emit('close')
                    this.errorMessage = error.response.data.errors
                    this.isLoading = false
                  }) 
            }
          } else {
            var username = this.input.username
            var password = this.input.password
            var cnfpassword = this.input.cnfpassword
            if (this.input.firstname === '') {
              this.errors.push('Name is Required')
              this.$refs.firstname.focus()
            } else if (firstname.length < 3) {
              this.errors.push('Name must be 3 characters long')
              this.$refs.firstname.focus()
            } else if (this.input.username === '') {
              this.errors.push('Username is Required')
              this.$refs.username.focus()
            } else if (username < 3) {
              this.errors.push('Username must be 3 characters long')
              this.$refs.username.focus()
            } else if (this.input.email === '') {
              this.errors.push('Email is Required')
              this.$refs.email.focus()
            } else if (!this.emailValidator.validate(this.input.email)) {
              this.errors.push('Invalid contact Email')
              this.$refs.email.focus()
            } else if (this.input.password === '') {
              this.errors.push('Password is Required')
              this.$refs.password.focus()
            } else if (password.length < 6) {
              this.errors.push('Password must be 6 characters long')
              this.$refs.password.focus()
            } else if (this.input.cnfpassword === '') {
              this.errors.push('Confirm Password is Required')
              this.$refs.cnfpassword.focus()
            } else if (this.input.password !== this.input.cnfpassword) {
              this.errors.push('Password & Confirm Password does not matched')
              this.$refs.cnfpassword.focus()
            } else {
              this.isLoading = true
              axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/createNewUser',
                {
                  firstname: firstname,
                  lastname: lastname,
                  username: username,
                  email: email,
                  role: userrole,
                  password: password,
                  confirm_password: cnfpassword
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': jwttoken
                  }})
                 .then(response => {
                  this.isLoading = false
                  this.$eventBus.$emit('listUser', 'User is Added successfully');
                  this.$emit('close')
                 })
                  .catch((error) => {
                    this.$eventBus.$emit('listUser', '','User could not be Added');
                    this.$emit('close')
                    this.errorMessage = error.response.data.errors
                    this.isLoading = false
                  }) 
            }
          }
        }
      },
      onChange () {
        var role = event.target.value
        if (role === 'user') {
          document.getElementById('username').style.display = 'none'
          document.getElementById('password').style.display = 'none'
          document.getElementById('cnfpassword').style.display = 'none'
        } else {
          document.getElementById('username').style.display = 'block'
          document.getElementById('password').style.display = 'block'
          document.getElementById('cnfpassword').style.display = 'block'
        }
      }
    },
    created () {
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AddUser.vue